<circle-progress
    [percent]="percentage"
    [radius]="radius"
    [outerStrokeWidth]="4"
    [innerStrokeWidth]="0"
    [outerStrokeColor]="progressColor"
    [animation]="false"
    [titleFontSize]="'16'"
    [subtitle]="subtitle"
></circle-progress>